<template>
  <div class="p-2">
    <!-- Form -->
    <form @submit.prevent="addDepartment" class="space-y-3">
      <!-- Department Name Input -->
      <div>
        <label for="departmentName" class="text-xs font-semibold text-gray-600 uppercase tracking-wide">
          Department Name <span class="text-danger">*</span>
        </label>
        <input
          id="departmentName"
          type="text"
          v-model="form.departmentName"
          placeholder="Enter department name"
          required
          class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50"
        />
      </div>

      <!-- Actions -->
      <div class="flex items-center justify-end gap-2 pt-2">
        <button
          type="submit"
          :disabled="loading || !form.departmentName"
          class="btn-primary">
          <span>Save Department</span>
        </button>
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { useConfigurationsStore } from "../../../stores";
import { useToast } from "@/composables";

// Types
interface DepartmentForm {
  departmentName: string | null
}

// Store and Composables
const store = useConfigurationsStore();
const { successToast, errorToast } = useToast()

// Reactive state
const form = ref<DepartmentForm>({
  departmentName: null
})
const loading = ref<boolean>(false)

// Methods
const addDepartment = () => {
  if (!form.value.departmentName) return

  loading.value = true
  store.createDepartment(form.value);
}

// Watch for success
watch(
  () => store.department,
  (department) => {
    if (department) {
      loading.value = false
      successToast('Success', 'Department created successfully')
      store.fetchDepartments();
      // Reset form
      form.value.departmentName = null
    }
  }
)

// Watch for error
watch(
  () => store.error,
  (error) => {
    if (error) {
      loading.value = false
      errorToast('Error', error.message || 'Department creation failed')
    }
  }
)
</script>

